import { useNavigate } from 'react-router';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';

import fuelNozzleImage from '@/assets/images/gas_nozzle_drop_mono.svg';
import gasStationImage from '@/assets/images/gas_station_mono.png';
import roadImage from '@/assets/images/road_car_coin_mono.png';
import { Button } from '@/shared/ui';

const SLIDES = [
	{
		key: 'road',
		text: '주변 주유소,\n가격 차이를 한눈에',
		image: roadImage,
		alt: 'road',
	},
	{
		key: 'gas-station',
		text: '어디서 넣으면\n얼마나 아끼는지 비교해요',
		image: gasStationImage,
		alt: 'gas station',
	},
	{
		key: 'fuel-nozzle',
		text: '주유는 그대로,\n비용은 더 가볍게',
		image: fuelNozzleImage,
		alt: 'fuel nozzle',
	},
] as const;

const OnboardingContent = () => {
	const navigate = useNavigate();

	return (
		<>
			<div className="flex w-full flex-1 items-center justify-center overflow-hidden">
				<Swiper
					modules={[Pagination, Autoplay]}
					pagination={{ clickable: true }}
					autoplay={{ delay: 3000, disableOnInteraction: false }}
					loop
					className="mantang-onboarding-swiper w-full"
				>
					{SLIDES.map(({ key, text, image, alt }) => (
						<SwiperSlide key={key}>
							<div className="flex flex-col items-center gap-8 px-5 pb-12">
								<h2 className="whitespace-pre-line text-center font-bold font-wavepado text-[32px] leading-11">
									{text}
								</h2>
								<img
									src={image}
									alt={alt}
									className="max-h-84 w-[82vw] max-w-[340px] object-contain"
								/>
							</div>
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="flex flex-col items-center gap-4 self-stretch px-5 pb-5">
				<Button className="max-w-none" onClick={() => navigate('/login')}>
					주유소 찾으러가기
				</Button>
			</div>
		</>
	);
};

export default OnboardingContent;
